/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useQuery } from "@tanstack/react-query";
import { getServiceTypes } from "./queryFunctions";

export const useServiceTypes = () => {
  return useQuery({
    queryKey: ["service-types"],
    queryFn: () => getServiceTypes(),
    staleTime: 5 * 60 * 1000, // 5 minutes - do not fetch project types again for about 5 minutes from last download
  });
};
